/**
 * Rota interna aberta ao clicar numa notificação (sino ou push).
 * Fonte única do mapeamento — também importada pelo service worker.
 */
export function notificationTargetPath(tipo: string, referenciaId: string | null): string | null {
  const id = referenciaId ? encodeURIComponent(referenciaId) : null
  const highlight = id ? `?highlight=${id}` : ''
  switch (tipo) {
    case 'COMUNICADO':
      return `/meus-comunicados${highlight}`
    case 'EVENTO':
    case 'LEMBRETE_EVENTO':
      return `/meus-eventos${highlight}`
    case 'ATENDIMENTO':
      // Detalhe da solicitação; sem referência, a lista de solicitações.
      return id ? `/atendimento/${id}` : '/atendimento'
    case 'INVENTARIO':
      // `referenciaId` é o `responsabilidadeId`: abre o aceite do termo do item.
      return `/meus-itens${highlight}`
    case 'CONTRACHEQUE':
      // "Meus contracheques" ainda não destaca item: `referenciaId` fica sem uso.
      return '/contracheque'
    case 'ATESTADO':
      // `referenciaId` é o colaborador dono do atestado (não o atestado): abre a ficha na aba.
      return id ? `/rh/colaboradores/${id}?aba=atestados` : '/rh/colaboradores'
    case 'FERIAS':
      // A tela lista poucos avisos e não destaca item: `referenciaId` (id do aviso) fica sem uso.
      return '/meus-avisos-ferias'
    default:
      return null
  }
}
